import {
  newContactFormSchema,
  toCreateContactBody,
} from "@features/Contacts/components/NewContactDialog/new-contact-form-helpers";
import { validateSocialHandleFields } from "@features/Contacts/components/ContactBriefingHeader/contact-summary-chips-helpers";
import type { ParsedCsvRow } from "./csv-import-helpers";

export type CsvContactFieldValues = Record<string, string>;

export type CsvContactRow = {
  id: string;
  values: CsvContactFieldValues;
  serverError?: string;
};

const CSV_HEADER_TO_FIELD_ID: Record<string, string> = {
  "First Name": "firstName",
  "Last Name": "lastName",
  "Full Name": "fullName",
  "Preferred Name": "preferredName",
  Email: "email",
  Phone: "phone",
  Company: "company",
  "Job Title": "jobTitle",
  Timezone: "timezone",
  Address: "address",
  City: "city",
  State: "state",
  "Postal Code": "postalCode",
  Instagram: "instagramHandle",
  LinkedIn: "linkedinHandle",
  Facebook: "facebookHandle",
  Links: "links",
};

export function toCsvContactRows(rows: ParsedCsvRow[]): CsvContactRow[] {
  return rows.map((row) => ({
    id: crypto.randomUUID(),
    values: Object.fromEntries(
      Object.entries(CSV_HEADER_TO_FIELD_ID).map(([header, fieldId]) => [
        fieldId,
        (row[header as keyof ParsedCsvRow] ?? "").trim(),
      ]),
    ),
  }));
}

type CsvRowValidation =
  | { valid: true }
  | { valid: false; errorsByField: Record<string, string> };

export function validateCsvContactRow(
  values: CsvContactFieldValues,
): CsvRowValidation {
  const parsed = newContactFormSchema.safeParse(toCreateContactBody(values));
  const errorsByField: Record<string, string> = {
    ...validateSocialHandleFields(values),
  };

  if (!parsed.success) {
    parsed.error.issues.forEach((issue) => {
      const [fieldId] = issue.path;
      if (typeof fieldId === "string" && !errorsByField[fieldId]) {
        errorsByField[fieldId] = issue.message;
      }
    });
  }

  if (Object.keys(errorsByField).length === 0) return { valid: true };
  return { valid: false, errorsByField };
}
